module.exports = __webpack_public_path__ + "media/student_contributors/01KataliaAlexander-5d4ae120.png";